module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetMedium.05aa5cb.webp";